import Emitter from "es6-event-emitter";
// eslint-disable-next-line
import topNavigationOverlay from "./../templates/topNavigationOverlay.dust"; // this is needed!
import {
  CLICKED_BACK_PAYWALL,
  CLICKED_CLOSE_PAYWALL,
  CLICKED_FORGOTPW_PAYWALL,
  CLICKED_LOGIN_PAYWALL,
  CLOSED_PAYWALL,
  FOCUS_PASSWORD_PAYWALL,
  FOCUS_USERNAME_PAYWALL,
  OPENED_PAYWALL,
  PAYWALL_LOGIN_AFTER_SHARE,
} from "./../../common/analytics/analyticsevents";
import {
  createError,
  disableAllScrolling,
  enableAllScrolling,
  getErrorMessage,
} from "./../../common/utilities/utils";
import language from "./../dictionary";
import paywall from "./../templates/paywall.dust";
import APIManager from "./../utilities/apimanager";
import {
  ABO_BANNER_DESKTOP,
  ABO_BANNER_MOBILE,
  PASSWORD_FORGOTTEN,
} from "./../utilities/redirectorKeys";

/**
 * Contstructs the Paywall view
 */
export default class Paywall extends Emitter {
  appState = null;
  authenticatorAuthorisationController = null;
  DOMContainer = null;
  options = null;

  publicationData = null;

  disabledScrolling = [];

  constructor(
    appState,
    authenticatorAuthorisationController,
    DOMContainer,
    options
  ) {
    super();
    this.appState = appState;
    this.authenticatorAuthorisationController =
      authenticatorAuthorisationController;
    this.DOMContainer = DOMContainer;
    this.options = options;
    this.render();
  }

  render() {
    if (this.DOMContainer !== null) {
      //create context
      const context = {};
      context.title = language.LogIn;
      context.close = true;
      context.back = true;
      context.email = language.Username;
      context.password = language.Password;
      context.cancel = language.Cancel;
      context.login = language.LogIn;
      context.forgot = language.ForgotPassword;
      context.showPassword = !this.options.noPasswordLogin;

      const aboBanner = this.appState.isDesktop
        ? ABO_BANNER_DESKTOP
        : ABO_BANNER_MOBILE;
      APIManager.getRedirectorUrl(
        aboBanner,
        this.appState.buildVersion,
        this.appState.userId,
        this.appState.downloadToken
      )
        .then((result) => {
          context.iframebannerSource = result;
        })
        .catch(() => {
          context.iframebannerSource = null;
        })
        .then(() => {
          Dust.render(paywall, context, (err, result) => {
            this.DOMContainer.innerHTML = result;
            this.attachClickHandlers();
          });
        });
    }
  }

  retreiveUrls() {}

  hide() {
    if (this.DOMContainer) {
      this.DOMContainer.classList.add("hidden");
    }
    enableAllScrolling(this.disabledScrolling);
    this.removeContentInput();
    //when focusing on input field and soft keybaord appears android scrolls to position input field in closest scrollcontainer from body!
    // -> will scroll in scroll-container-kiosque and therefore this needs to be reset to 0
    // let scroll = document.querySelector('body');
    // if(scroll) {
    //   scroll.scrollTop = 0;
    // }
    this.appState.triggerEvent(CLOSED_PAYWALL);
  }

  show(publicationData = null, title = null) {
    this.publicationData = publicationData;
    if (this.DOMContainer) {
      const back = this.DOMContainer.querySelector(".overlay-navigation-back");
      const titleContainer = this.DOMContainer.querySelector(
        ".overlay-navigation-title"
      );
      if (back && titleContainer) {
        if (title) {
          titleContainer.innerHTML = title;
          this.DOMContainer.classList.remove("showOverlay");
          back.classList.remove("hidden");
        } else {
          titleContainer.innerHTML = language.LogIn;
          this.DOMContainer.classList.add("showOverlay");
          back.classList.add("hidden");
        }
      }
      this.DOMContainer.classList.remove("hidden");
      this.disabledScrolling = disableAllScrolling();
      //Load iframe after the paywal is displayed to avoid having wrong height
      this.loadIframe();
      this.appState.triggerEvent(OPENED_PAYWALL);
    }
  }

  attachClickHandlers() {
    if (this.DOMContainer !== null) {
      $(this.DOMContainer).on("click", (e) => {
        if (e.target === this.DOMContainer) {
          e.preventDefault();
          this.hide();
          this.trigger("paywall:close");
        }
      });
      $(this.DOMContainer).on("click", ".overlay-navigation-close", () => {
        this.onClose();
      });
      $(this.DOMContainer).on("click", ".overlay-navigation-back", () => {
        this.onBack();
      });
      $(this.DOMContainer).on("click", ".paywall-button-login", () => {
        this.onSubmit();
      });
      $(this.DOMContainer).on("click", ".forgot-password", () => {
        this.onPasswordForgotten(language.passwordForgottenLoadingText);
      });
      $("#login-username", this.DOMContainer).on(
        "focus",
        this.usernameFieldFocusHandler.bind(this)
      );
      $("#login-password", this.DOMContainer).on(
        "focus",
        this.passwordFieldFocusHandler.bind(this)
      );
    }
    const inputUserName = this.DOMContainer.querySelector("#login-username");
    if (inputUserName !== null) {
      inputUserName.addEventListener("keyup", (e) => {
        this.onKeyUpUserName(e);
      });
      inputUserName.addEventListener("focus", () => {
        // this.scrollIntoView();   //TODO: not good solution: interfers with native centering input
      });
    }
    const inputPassword = this.DOMContainer.querySelector("#login-password");
    if (inputPassword !== null) {
      inputPassword.addEventListener("keyup", (e) => {
        this.onKeyUpPassword(e);
      });
      inputPassword.addEventListener("focus", () => {
        // this.scrollIntoView();
      });
    }
    // let virtualKeyboard = new VirtualKeyboard();
    // virtualKeyboard.on('keyboardVisible', this.keyboardVisible);
    // virtualKeyboard.on('keyboardHidden', this.keyboardHidden);
  }

  scrollIntoView() {
    if (this.appState.isTablet) {
      const inputUserName = this.DOMContainer.querySelector("#login-username");
      if (inputUserName) {
        const offsetTop = $(inputUserName).offset().top;
        $("html,body").scrollTop(offsetTop - 100);
      }
    }
  }

  onClose() {
    this.hide();
    this.appState.triggerEvent(CLICKED_CLOSE_PAYWALL);
    this.trigger("paywall:close");
  }

  onBack() {
    this.hide();
    this.appState.triggerEvent(CLICKED_BACK_PAYWALL);
    this.trigger("paywall:back");
  }

  isAValidEmail(email) {
    if (
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,20}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/.test(
        email
      )
    ) {
      return true;
    }
    return false;
  }

  onSubmit() {
    const userName = $.trim($(this.DOMContainer).find("#login-username").val());
    const password = this.options.noPasswordLogin
      ? "123456"
      : $.trim($(this.DOMContainer).find("#login-password").val());

    //if one of the fields is empty show error
    if (userName.length === 0 || password.length === 0) {
      this.showError(
        createError("PW-FIELDS", "Not all fields are filled in", {})
      );
    } else if (
      this.options.subscription_validate_email &&
      !this.isAValidEmail(userName)
    ) {
      this.showError(createError("PW-EMAIL", "Username is not an email", {}));
    } else {
      this.login(userName, password);
    }
    this.appState.triggerEvent(CLICKED_LOGIN_PAYWALL);
  }

  onPasswordForgotten(loadingScreenText) {
    const emptyWindow = window.open("", "_blank");
    emptyWindow.document.write(loadingScreenText);
    this.appState.triggerEvent(CLICKED_FORGOTPW_PAYWALL);
    APIManager.getRedirectorUrl(
      PASSWORD_FORGOTTEN,
      this.appState.buildVersion,
      this.appState.userId,
      this.appState.downloadToken
    )
      .then((result) => {
        if (result.substr(0, 7).toLowerCase() === "mailto:") {
          window.location.href = result;
        } else {
          //window.open(result);
          emptyWindow.location.href = result;
        }
      })
      .catch(() => {
        //TODO: do nothing?
      });
  }

  onKeyUpUserName(e) {
    if (e.keyCode === 13) {
      this.DOMContainer.querySelector("#login-password").focus();
    }
  }

  onKeyUpPassword(e) {
    if (e.keyCode === 13) {
      this.DOMContainer.querySelector(".paywall-button-login").click();
    }
  }

  usernameFieldFocusHandler() {
    if (!this.DOMContainer.classList.contains("hidden")) {
      this.appState.triggerEvent(FOCUS_USERNAME_PAYWALL);
    }
  }

  passwordFieldFocusHandler() {
    if (!this.DOMContainer.classList.contains("hidden")) {
      this.appState.triggerEvent(FOCUS_PASSWORD_PAYWALL);
    }
  }

  login(userName, password) {
    this.showLoader();
    if (this.publicationData) {
      this.authenticatorAuthorisationController
        .authorizeByUserNamePassword(
          userName,
          password,
          this.publicationData,
          this.appState.isReader
        )
        .then(() => {
          // This is a workaround of the issue with direct access. When we have no valid session and we go directly to a publication,
          // publication will be downloaded in parellel with authorization. But we need to be authorized before downloading images ->
          // secure links (secure links demand session reader cookie). This is a corner case, so we do here this huck to be sure
          // that in time we download publication we already have session reader cookie created.
          // not needed anymore since authorisation now happens before opening
          // if (this.appState.isReader && !this.appState.socialSharing) window.location.reload();

          this.hide();
          this.trigger("paywall:authorizeSucces", this.publicationData);
          if (this.appState.socialSharing) {
            this.appState.triggerEvent(PAYWALL_LOGIN_AFTER_SHARE);
          }
          if (this.appState.isReader && !this.appState.socialSharing)
            window.location.reload();
        })
        .catch((error) => {
          this.showError(error);
        })
        .then(() => {
          this.hideLoader();
        });
    } else {
      this.authenticatorAuthorisationController
        .authenticateByUserNamePassword(userName, password)
        .then(() => {
          this.hide();
        })
        .catch((error) => {
          this.showError(error);
        })
        .then(() => {
          this.hideLoader();
        });
    }
  }

  hideLoader() {
    const loader = this.DOMContainer.querySelector(".loader-container");
    if (loader) {
      loader.classList.add("hidden");
    }
  }

  showLoader() {
    const loader = this.DOMContainer.querySelector(".loader-container");
    if (loader) {
      loader.classList.remove("hidden");
    }
  }

  hideError() {
    const errorContainer = this.DOMContainer.querySelector(".paywall-error");
    if (errorContainer) {
      errorContainer.classList.add("hidden");
    }
  }

  showError(error) {
    if (error) {
      const message = getErrorMessage(error, language);
      const errorContainer = this.DOMContainer.querySelector(".paywall-error");
      if (errorContainer) {
        errorContainer.innerHTML = message;
        errorContainer.classList.remove("hidden");
      }
    }
  }

  //TODO: scrolling
  scrollToLoginInput() {
    const inputToScrol = this.DOMContainer.querySelector("#login-username");
    const paywallMain = this.DOMContainer.querySelector(".paywall-main");
    if (inputToScrol && paywallMain) {
      const rectInput = inputToScrol.getBoundingClientRect();
      const rectBody = paywallMain.getBoundingClientRect();
      const diff = rectInput.top - rectBody.top;
      const total = diff - 10;
      paywallMain.scrollTop += total;
    }
  }

  removeContentInput() {
    $(this.DOMContainer).find("#login-username").val("");
    $(this.DOMContainer).find("#login-password").val("");
    this.hideError();
  }

  loadIframe() {
    const iframe = this.DOMContainer.querySelector("#abo-banner-iframe");
    if (iframe !== null && iframe.src === "") {
      iframe.src = iframe.getAttribute("data-url");
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/paywall.js